module.exports = __webpack_public_path__ + "static/media/context-blue.40b3a434.svg";